import { __read, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default, { useRef, useState, useEffect } from 'react';
import classNames from './../../external_lib/classnames/index.js';
import HorizonModal from '../../base/HorizonModal/index.js';
import Invoice from '../../assets/icons/jsx/Invoice.js';
import styles from '../../components/sublayouts/InvoicePaymentAlert/index.module.scss.js';
var PaymentVariant;
(function (PaymentVariant) {
  PaymentVariant["Pending"] = "pending";
  PaymentVariant["Overdue"] = "overdue";
  PaymentVariant["Deactivation"] = "deactivation";
})(PaymentVariant || (PaymentVariant = {}));
function InvoicePaymentAlert(_a) {
  var _b;
  var _c = _a.className,
    className = _c === void 0 ? '' : _c,
    _d = _a.type,
    type = _d === void 0 ? PaymentVariant.Pending : _d,
    _e = _a.open,
    open = _e === void 0 ? false : _e,
    onClose = _a.onClose,
    onSubmit = _a.onSubmit,
    _f = _a.okText,
    okText = _f === void 0 ? 'View Invoices' : _f,
    _g = _a.cancelText,
    cancelText = _g === void 0 ? 'I understand' : _g,
    _h = _a.body,
    body = _h === void 0 ? null : _h,
    _j = _a.title,
    title = _j === void 0 ? null : _j,
    _k = _a.modalProps,
    modalProps = _k === void 0 ? {} : _k,
    _l = _a.cancelButtonProps,
    cancelButtonProps = _l === void 0 ? {} : _l;
  var timer = useRef();
  var _m = __read(useState(type !== PaymentVariant.Pending), 2),
    disabledBtn = _m[0],
    setDisabledBtn = _m[1];
  useEffect(function () {
    if (open) {
      handleBtnDisable();
    }
    if (!open) {
      clearTimeout(timer.current);
    }
    return function () {
      clearTimeout(timer.current);
    };
  }, [open, type]);
  var handleBtnDisable = function () {
    clearTimeout(timer.current);
    if (type === PaymentVariant.Pending) {
      setDisabledBtn(false);
      return;
    }
    setDisabledBtn(true);
    timer.current = setTimeout(function () {
      setDisabledBtn(false);
    }, 10200);
  };
  var renderTitle = function () {
    return React__default.createElement("div", {
      className: "flex items-center gap-3"
    }, React__default.createElement(Invoice, {
      className: styles.invoiceIcon
    }), title);
  };
  return React__default.createElement(HorizonModal, __assign({
    open: open,
    title: renderTitle(),
    okText: okText,
    cancelText: cancelText,
    cancelButtonProps: __assign({
      danger: true,
      disabled: disabledBtn
    }, cancelButtonProps !== null && cancelButtonProps !== void 0 ? cancelButtonProps : {}),
    closable: false,
    maskClosable: false,
    onCancel: onClose,
    onOk: onSubmit,
    width: 575,
    className: classNames(styles.invoicePayment, styles === null || styles === void 0 ? void 0 : styles[type], (_b = {}, _b[styles.withTimer] = disabledBtn, _b), className),
    classNames: {
      mask: styles.modalMask,
      content: styles.modalContent
    },
    centered: true,
    keyboard: false
  }, modalProps), type !== PaymentVariant.Pending && React__default.createElement("div", {
    className: styles.progressBar
  }), body);
}
export { PaymentVariant, InvoicePaymentAlert as default };
//# sourceMappingURL=index.js.map
